(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treviia-community"] && !Shopify.designMode) return;
  try {
    
  /**
   * Picks one image from the block list, and optionally rotates.
   *
   * No library and no preloading: the candidates arrive as a delimited string
   * and exactly one src is ever assigned, so a section with eight images still
   * costs one request.
   */
  class TreviiaShuffle extends HTMLElement {
    connectedCallback() {
      const img = this.querySelector('img');
      const srcs = (this.dataset.srcs || '').split('|').filter(Boolean);
      if (!img || !srcs.length) return;

      this.img = img;
      this.srcs = srcs;
      this.show(Math.floor(Math.random() * srcs.length));

      const seconds = parseInt(this.dataset.rotate || '0', 10);
      if (seconds > 0 && srcs.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(() => {
          // Never repeat the frame that is already up.
          let next = this.index;
          while (next === this.index) next = Math.floor(Math.random() * this.srcs.length);
          this.show(next);
        }, seconds * 1000);
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    show(i) {
      this.index = i;
      const swap = () => {
        this.img.src = this.srcs[i];
        this.img.classList.add('is-shown');
      };
      if (!this.img.classList.contains('is-shown')) return swap();
      // Fade out, swap, fade back in — otherwise the change is a hard cut.
      this.img.classList.remove('is-shown');
      setTimeout(swap, 320);
    }
  }

  if (!customElements.get('tv-shuffle')) customElements.define('tv-shuffle', TreviiaShuffle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treviia-companion"] && !Shopify.designMode) return;
  try {
    
  /**
   * Drives the scroll companion.
   *
   * Scroll position is read from the element's own scroller rather than
   * window.scrollY: Horizon gives .page-wrapper `overflow-y: auto` at >=990px
   * (base.css:52), so on desktop the window never scrolls and scroll events do
   * not reach a window listener. Capturing on document covers both cases.
   */
  class TreviiaCompanion extends HTMLElement {
    connectedCallback() {
      this.stages = Array.from(this.querySelectorAll('.tv-comp__stage'));
      if (!this.stages.length) return;

      this.startAt = parseFloat(this.dataset.start || '12') / 100;
      this.endAt = parseFloat(this.dataset.end || '88') / 100;
      this.threshold = parseInt(this.dataset.threshold || '0', 10);
      this.key = this.dataset.storageKey || 'tv-comp';

      if (this.readDismissed()) return;

      this.cartEl = this.querySelector('[data-tv-comp-cart]');
      this.hit = this.querySelector('[data-tv-comp-hit]');
      this.fallbackHref = this.hit?.getAttribute('href') || '';
      this.index = -1;
      this.lastY = 0;
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      this.onCartUpdate = this.onCartUpdate.bind(this);

      this.querySelector('[data-tv-comp-close]')?.addEventListener('click', () => this.dismiss());

      document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
      document.addEventListener('shopify:cart:lines-update', this.onCartUpdate);

      this.refreshCart();
      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('scroll', this.onScroll, { capture: true });
      document.removeEventListener('shopify:cart:lines-update', this.onCartUpdate);
    }

    /**
     * True while a full-viewport "solo" section is covering the screen.
     * Measured with getBoundingClientRect so it is scroller-agnostic —
     * .page-wrapper scrolls on desktop, the document scrolls on phones.
     */
    soloCovers() {
      if (this.solo === undefined) this.solo = document.querySelector('[data-tv-solo]');
      if (!this.solo) return false;
      const r = this.solo.getBoundingClientRect();
      return r.top <= 0 && r.bottom >= window.innerHeight * 0.9;
    }

    /** The element that actually scrolls: .page-wrapper on desktop, else the document. */
    scroller() {
      const wrapper = document.querySelector('.page-wrapper');
      if (wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1) return wrapper;
      return document.scrollingElement || document.documentElement;
    }

    readDismissed() {
      try {
        return sessionStorage.getItem(this.key) === '1';
      } catch {
        return false;
      }
    }

    dismiss() {
      try {
        sessionStorage.setItem(this.key, '1');
      } catch {
        /* private mode — dismissing just won't persist */
      }
      this.hidden = true;
      this.disconnectedCallback();
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const el = this.scroller();
      const max = el.scrollHeight - el.clientHeight;
      if (max <= 0) return;
      const y = el.scrollTop;
      const p = y / max;

      const inRange = p >= this.startAt && p <= this.endAt;
      this.hidden = !inRange;
      if (!inRange) return;

      // A [data-tv-solo] section (the pinned video stage) owns the whole
      // viewport while it is on screen. Standing on it puts this panel on top
      // of that section's button and progress rail, so step aside completely.
      if (this.soloCovers()) {
        this.classList.add('is-away');
        this.lastY = y;
        return;
      }

      // Reading is scrolling down — get out of the way, come back on the pause.
      const goingDown = y > this.lastY + 4;
      const goingUp = y < this.lastY - 4;
      if (window.matchMedia('(max-width: 989px)').matches) {
        if (goingDown) this.classList.add('is-away');
        else if (goingUp) this.classList.remove('is-away');
        clearTimeout(this.idle);
        this.idle = setTimeout(() => this.classList.remove('is-away'), 420);
      } else {
        this.classList.remove('is-away');
      }
      this.lastY = y;

      // Last stage whose threshold has been passed.
      let next = 0;
      this.stages.forEach((s, i) => {
        if (p * 100 >= parseFloat(s.dataset.at || '0')) next = i;
      });
      if (next !== this.index) {
        this.index = next;
        this.stages.forEach((s, i) => s.classList.toggle('is-active', i === next));
        // The card and its button are one link, so they can never disagree.
        if (this.hit) {
          const href = this.stages[next]?.querySelector('[data-href]')?.dataset.href;
          this.hit.setAttribute('href', href || this.fallbackHref);
        }
      }
    }

    onCartUpdate() {
      clearTimeout(this.cartTimer);
      this.cartTimer = setTimeout(() => this.refreshCart(), 140);
    }

    money(cents) {
      const whole = cents % 100 === 0;
      return `EGP ${(cents / 100).toLocaleString('en-EG', {
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: 2,
      })}`;
    }

    async refreshCart() {
      if (!this.cartEl) return;
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        // A rate-limited storefront answers 429 with an HTML body, which would
        // throw inside json() and look like an empty cart.
        if (!res.ok) return;
        const cart = await res.json();
        const count = cart.item_count ?? 0;
        this.cartEl.hidden = count === 0;
        if (!count) return;

        const total = cart.total_price ?? 0;
        const remaining = this.threshold - total;
        const pct = Math.max(0, Math.min(100, (total / this.threshold) * 100));

        this.querySelector('[data-tv-comp-cart-fill]').style.width = `${pct}%`;
        this.querySelector('[data-tv-comp-cart-count]').textContent =
          `${count} item${count === 1 ? '' : 's'}`;
        this.querySelector('[data-tv-comp-cart-text]').textContent =
          remaining > 0 ? `${this.money(remaining)} to free shipping` : 'Free shipping unlocked';
        this.classList.toggle('is-unlocked', remaining <= 0);
      } catch {
        /* keep the last good state */
      }
    }
  }

  if (!customElements.get('tv-companion')) customElements.define('tv-companion', TreviiaCompanion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treviia-hero"] && !Shopify.designMode) return;
  try {
    
  /**
   * Scroll-linked motion for the hero.
   *
   * Wall mode: each column gets a parallax offset on top of its CSS marquee.
   * Photo mode: a very small scale on the image.
   *
   * Scroll is measured from the element's own viewport rect rather than
   * window.scrollY, because Horizon gives .page-wrapper `overflow-y: auto` at
   * >=990px (base.css:52) and the window never scrolls there.
   */
  class TreviiaHero extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.mode = this.dataset.mode;
      this.cols = Array.from(this.querySelectorAll('.tv-hero__col'));
      this.imgs = Array.from(this.querySelectorAll('.tv-hero__img'));
      if (!this.cols.length && !this.imgs.length) return;

      this.speed = parseFloat(this.dataset.speed || '0.18');
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);

      this.io = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.update();
      });
      this.io.observe(this);

      // Capture on document: scroll events do not bubble, and the scroller is
      // .page-wrapper on desktop.
      document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('scroll', this.onScroll, { capture: true });
      this.io?.disconnect();
    }

    onScroll() {
      if (this.ticking || !this.visible) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const rect = this.getBoundingClientRect();
      // How far the hero has travelled up past the top of the viewport.
      const y = Math.max(0, -rect.top);

      if (this.mode === 'photo') {
        const p = Math.min(1, y / Math.max(1, rect.height));
        this.style.setProperty('--tv-hero-zoom', (1 + p * this.speed * 0.6).toFixed(4));
        return;
      }

      this.cols.forEach((col, i) => {
        // Alternate direction so adjacent columns separate as the page moves.
        const dir = i % 2 === 0 ? 1 : -1;
        const factor = this.speed * (1 + (i % 2) * 0.45);
        col.style.transform = `translate3d(0, ${(y * factor * dir).toFixed(1)}px, 0)`;
      });
    }
  }

  if (!customElements.get('tv-hero')) customElements.define('tv-hero', TreviiaHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treviia-scrub"] && !Shopify.designMode) return;
  try {
    
  /**
   * Maps scroll progress through the track onto video.currentTime.
   *
   * currentTime is set inside rAF and only when the delta is meaningful —
   * assigning it on every scroll event queues seeks faster than the decoder
   * retires them, which is what makes naive versions of this stutter.
   */
  class TreviiaScrub extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.fill = this.querySelector('.tv-scrub__railfill');
      this.phases = Array.from(this.querySelectorAll('.tv-scrub__phase'));

      // The magic-mug clip opens on ~0.8s of empty white table before the mug
      // lands, which is the frame a visitor arrives on. Trim it off.
      this.trimStart = (parseFloat(this.dataset.trimStart) || 0) / 100;
      this.trimEnd = (parseFloat(this.dataset.trimEnd) || 100) / 100;

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.target = 0;
      this.current = 0;
      this.raf = null;
      this.visible = true;
      this.wantTime = 0;
      this.seekBusy = false;

      // One seek per this many seconds of clip. A phone cannot retire 60 seeks
      // a second, and queuing them is what makes the picture freeze and then
      // jump; a coarser step there is smoother than a finer one it cannot meet.
      this.coarse = window.matchMedia('(max-width: 989px), (pointer: coarse)').matches;
      this.threshold = this.coarse ? 0.07 : 0.03;
      this.ease = this.coarse ? 0.22 : 0.14;

      this.setPhase(0);

      if (this.reduced) {
        this.playFallback();
        return;
      }

      this.onScroll = this.onScroll.bind(this);
      this.tick = this.tick.bind(this);
      this.onSeeked = this.onSeeked.bind(this);

      if (this.video) {
        // Desktop upgrades to the larger rendition. Done before any buffering
        // so the phone never pays for a file it will not use.
        const hd = this.video.dataset.srcHd;
        if (hd && !this.coarse && hd !== this.video.getAttribute('src')) {
          this.video.src = hd;
        }
        // Scrubbing needs the clip buffered, not just its metadata.
        this.video.preload = 'auto';
        this.video.load();

        this.video.addEventListener('seeked', this.onSeeked);
        this.video.addEventListener('loadedmetadata', () => this.start(), { once: true });
        this.video.addEventListener('error', () => this.playFallback(), { once: true });
        if (this.video.readyState >= 1) this.start();
        setTimeout(() => {
          if (!this.started) this.playFallback();
        }, 6000);
      } else {
        this.start();
      }

      // Only run the loop while the section is actually on screen.
      this.io = new IntersectionObserver(
        (entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) {
            if (this.started && !this.raf) this.tick();
          } else if (this.raf) {
            cancelAnimationFrame(this.raf);
            this.raf = null;
          }
        },
        { rootMargin: '15% 0px' }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      document.removeEventListener('scroll', this.onScroll, { capture: true });
      this.video?.removeEventListener('seeked', this.onSeeked);
      this.io?.disconnect();
      clearTimeout(this.seekGuard);
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = null;
    }

    start() {
      if (this.started) return;
      this.started = true;

      this.prime();

      // See the hero: .page-wrapper is the scroller on desktop, and scroll
      // events do not bubble, so this must capture on document.
      document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
      this.onScroll();
      this.tick();
    }

    /**
     * iOS Safari will not paint a frame for a <video> that has never played —
     * assigning currentTime leaves the element transparent, which renders as an
     * empty dark box where the clip should be. A muted play() followed
     * immediately by pause() decodes one frame and unsticks it for good.
     */
    async prime() {
      const v = this.video;
      if (!v || this.primed) return;
      this.primed = true;
      v.muted = true;
      try {
        await v.play();
        v.pause();
      } catch {
        // Autoplay refused: prime on the first touch instead.
        this.primed = false;
        const kick = () => {
          this.primed = false;
          this.prime();
        };
        document.addEventListener('touchstart', kick, { once: true, passive: true });
        document.addEventListener('pointerdown', kick, { once: true, passive: true });
        return;
      }
      // Park on the trimmed start so the section never shows the blank opening
      // frame while it is still below the fold.
      if (v.duration) this.seekTo(this.trimStart * v.duration, true);
    }

    /**
     * Seek pump. A new seek is only issued when the previous one has landed, so
     * scroll can outrun the decoder without queuing work it will never retire.
     * The scroll position keeps updating `wantTime`; `seeked` pulls the next one.
     */
    seekTo(t, force) {
      const v = this.video;
      if (!v || !v.duration || !isFinite(v.duration)) return;

      t = Math.max(0, Math.min(v.duration - 0.05, t));
      this.wantTime = t;

      if (this.seekBusy && !force) return;
      if (!force && Math.abs(t - v.currentTime) < this.threshold) return;

      this.seekBusy = true;
      clearTimeout(this.seekGuard);
      // A seek landing on the frame already shown fires no `seeked` on some
      // engines; without this guard the pump would stall permanently.
      this.seekGuard = setTimeout(this.onSeeked, 400);
      v.currentTime = t;
    }

    onSeeked() {
      clearTimeout(this.seekGuard);
      this.seekBusy = false;
      const v = this.video;
      if (!v) return;
      if (Math.abs(this.wantTime - v.currentTime) > this.threshold) this.seekTo(this.wantTime);
    }

    playFallback() {
      if (this.started) return;
      this.started = true;
      this.classList.add('tv-scrub--fallback');
      if (this.video) {
        this.video.loop = true;
        this.video.muted = true;
        this.video.play().catch(() => {});
      }
      this.setPhase(0);
    }

    progress() {
      const rect = this.getBoundingClientRect();
      const scrollable = rect.height - window.innerHeight;
      if (scrollable <= 0) return 0;
      return Math.min(1, Math.max(0, -rect.top / scrollable));
    }

    onScroll() {
      this.target = this.progress();
    }

    setPhase(i) {
      this.phases.forEach((p, n) => p.classList.toggle('is-active', n === i));
    }

    tick() {
      if (!this.visible) {
        this.raf = null;
        return;
      }
      this.raf = requestAnimationFrame(this.tick);

      // Ease toward the scroll target so a fast flick does not thrash the decoder.
      this.current += (this.target - this.current) * this.ease;
      const p = this.current;

      if (this.fill) this.fill.style.width = `${(p * 100).toFixed(1)}%`;

      if (this.phases.length) {
        const idx = Math.min(this.phases.length - 1, Math.floor(p * this.phases.length));
        if (idx !== this.phaseIndex) {
          this.phaseIndex = idx;
          this.setPhase(idx);
        }
      }

      const v = this.video;
      if (v && v.duration && isFinite(v.duration)) {
        this.seekTo((this.trimStart + p * (this.trimEnd - this.trimStart)) * v.duration);
      }
    }
  }

  if (!customElements.get('tv-scrub')) customElements.define('tv-scrub', TreviiaScrub);

  } catch(e) { console.error(e); }
})();
})();
